import { FiLogOut, FiUser } from "react-icons/fi";
import { useState } from "react";

const UserHeader = ({ profile, onLogout }) => {
  const [imageError, setImageError] = useState(false);

  const statusMessages = {
    Pending: "Please complete your profile.",
    Revisit: "Your profile is in review",
    Approved: "Your profile is in review",
    Onboarded: "You are successfully onboarded on UDrivo",
    Rejected: "Your profile is in review",
    InProgress: "Your profile is in review",
  };

  return (
    <div className="mb-8">
      {/* Header Section */}
      <div className="flex justify-between items-center border-b border-gray-300 pb-4">
        {/* Profile Image */}
        {profile.profileImage && !imageError ? (
          <img
            src={profile.profileImage}
            alt="Profile"
            className="w-10 h-10 rounded-full border-2 border-indigo-500 object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <div className="w-10 h-10 flex items-center justify-center rounded-full border-2 border-indigo-500 bg-gray-100">
            <FiUser className="text-indigo-500 w-6 h-6" />
          </div>
        )}

        {/* Phone Number */}
        <span className="text-lg font-medium text-gray-800 tracking-wide">
          {profile.fullName?.trim() ? profile.fullName : profile.phone}
        </span>

        {/* Logout Button */}
        <button
          aria-label="Logout"
          className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-red-100 transition duration-200"
          onClick={onLogout}
        >
          <FiLogOut className="w-6 h-6 text-red-600" />
        </button>
      </div>

      {/* Status Message */}
      {profile?.status && (
        <div className="mt-4 bg-blue-50 border border-blue-300 text-blue-800 p-4 rounded shadow-sm">
          <strong>Status:</strong>{" "}
          {statusMessages[profile.status] || "Unknown status"}
        </div>
      )}
    </div>
  );
};

export default UserHeader;
